import { render, staticRenderFns } from "./WorkingTimeSetups.vue?vue&type=template&id=4a4cf55a&scoped=true"
import script from "./WorkingTimeSetups.vue?vue&type=script&lang=js"
export * from "./WorkingTimeSetups.vue?vue&type=script&lang=js"
import style0 from "./WorkingTimeSetups.vue?vue&type=style&index=0&id=4a4cf55a&prod&scoped=true&lang=css"
import style1 from "./WorkingTimeSetups.vue?vue&type=style&index=1&id=4a4cf55a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4cf55a",
  null
  
)

export default component.exports